/*
 * @Author: liji
 * @Date: 2022-10-25 20:30:44
 * @LastEditors: liji
 * @LastEditTime: 2023-03-24 10:47:13
 * @Description: file content
 */
import axios from "axios";
import type { AxiosInstance } from "axios";
import type { HYRequestInterceptors, HYRequestConfig } from "./type";
import { showFailToast } from "vant";
import { apiSign } from "./method";
import GlobalServices from "@/services/global";
import { useRouter } from "vue-router";
const router = useRouter();
class HYRequest {
	instance: AxiosInstance; //axios实例
	interceptors?: HYRequestInterceptors;

	constructor(config: HYRequestConfig) {
		this.instance = axios.create(config);
		//添加所有实例的拦截器
		this.instance.interceptors.request.use(
			(config) => {
				if (GlobalServices.state.baseUrl) {
					if (config.url?.includes("upload_log")) {
						config.baseURL = GlobalServices.state.baseUrl + "/ipc_web";
					} else {
						config.baseURL = GlobalServices.state.baseUrl + "/web";
					}
				}

				config.headers["Content-Type"] = "application/json";
				const signConfig = apiSign(config);
				return signConfig;
			},
			(err) => {
				return err;
			}
		);
		this.instance.interceptors.response.use(
			(res) => {
				return res;
			},
			(err) => {
				return err;
			}
		);
	}

	request<T>(config: HYRequestConfig): Promise<T> {
		console.debug("request config", config);
		return new Promise((resolve, reject) => {
			this.instance.request<any, any>(config).then((res) => {
				if (res.status === 200) {
					const data = res.data;
					const code = data.code;
					if (code === "1001") {
						resolve(res.data.data);
					} else if (code === "1018") {
						showFailToast("账号不存在");
					} else if (code === "1017") {
						showFailToast("密码错误");
					} else if (code === "1023") {
						GlobalServices.state.userId = "";
						GlobalServices.state.userToken = "";
						sessionStorage.setItem("userInfo", "");
						GlobalServices.state.showLogin = true;
						showFailToast("登录过期");
						window.location.hash = "/";
					} else {
						reject(code);
					}
				} else {
					reject("request err");
					showFailToast("网路错误");
					return;
				}
				console.debug("request res", res);
				//将结果res返回出去
				resolve(res);
			});
		});
	}
}

export default HYRequest;
